import type { TFunction } from "i18next";
import type { ToolCallPayload } from "../../../api/threads/liveMessages";

/**
 * A tool call in one line (web-app.md WA-4). A call that succeeded reads as its tool's own
 * line; a failure as the tool and its recorded reason (LRG-4); a call without a line as a
 * generic one. No tool has a case here: the tools own their lines on the server.
 */

/** The recorded failure reason, shared with the exact-call details. */
export function toolCallProblemDetail(payload: ToolCallPayload): string | null {
  const problem = payload.result_summary["problem"];
  return problem !== null && typeof problem === "object" && "detail" in problem && typeof problem.detail === "string" ? problem.detail : null;
}

export function callLine(payload: ToolCallPayload, language: string | undefined, t: TFunction): string {
  if (payload.outcome !== "ok") {
    return t("threads.toolCall.failed", { tool: payload.tool, reason: toolCallProblemDetail(payload) ?? payload.outcome });
  }
  const line = payload.summary;
  if (line === undefined || line === null) {
    return t("threads.toolCall.generic", { tool: payload.tool });
  }
  return language?.startsWith("de") === true ? line.de : line.en;
}
